export const MODULE_NAME = 'feedApp';
